
/* eslint-disable @typescript-eslint/camelcase */
import { defineComponent, onMounted } from "vue";
import { fetchUsers, userListener, allUsers } from "@/vuetils/useUser";
export default defineComponent({
  name: "Users",
  async setup() {
    onMounted(() => {
      userListener.subscribe();
    });

    await fetchUsers();

    console.log("got users in component", allUsers.value);

    return { allUsers };
  }
});
